export const environment = {
  production: true,
  apiUrl:'https://api.99gift.in/company/'
};
